import PlayerPause from './src/player-pause-combined';
export default PlayerPause;